module.exports = __webpack_public_path__ + "static/media/cq_sinistri_collegati_pratica b.b9cadb15.svg";